import { render, staticRenderFns } from "./AddComplain.vue?vue&type=template&id=79aabae3&scoped=true&"
import script from "./AddComplain.vue?vue&type=script&lang=js&"
export * from "./AddComplain.vue?vue&type=script&lang=js&"
import style0 from "./AddComplain.vue?vue&type=style&index=0&id=79aabae3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aabae3",
  null
  
)

export default component.exports